import { hasVideoInput, clampTo } from '../../tools';
import type { WavespeedModelConfig } from '../types';

// 视频超分模型列表
export const VIDEO_UPSCALER_MODELS = [
    'wavespeed-ai/video-upscaler',
    'wavespeed-ai/video-upscaler-pro',
    'wavespeed-ai/ultimate-video-upscaler',
    'wavespeed-ai/seedvr2/video',
    'wavespeed-ai/flashvsr',
] as const;

// 默认视频超分模型
export const DEFAULT_VIDEO_UPSCALER_MODEL = 'wavespeed-ai/flashvsr';

export const upscalerConfigs: Record<string, WavespeedModelConfig> = {
    // 视频 AI 超分
    'video-upscaler': {
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/video-upscaler
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/video-upscaler-pro
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/ultimate-video-upscaler
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/seedvr2/video
        // https://wavespeed.ai/zh-CN/models/wavespeed-ai/flashvsr
        apiPath: (params) => {
            const selected = params.modelUi?.upscaler_model;
            const model = VIDEO_UPSCALER_MODELS.includes(selected)
                ? selected
                : DEFAULT_VIDEO_UPSCALER_MODEL;
            return `/${model}`;
        },
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { videoUri, quality } = params;
            return {
                // 视频 URL
                video: videoUri,
                // 可选参数
                target_resolution: clampTo(quality || '4k', ['720p', '1080p', '2k', '4k'] as const, '4k'),
            };
        },
    },
    // 视频 AI 补帧
    'wavespeed-ai/video-fps-increaser': {   
        // https://wavespeed.ai/models/wavespeed-ai/video-fps-increaser
        apiPath: '/wavespeed-ai/video-fps-increaser',
        pollApiPath: '/predictions/${requestId}/result',
        enableTranslation: false,
        buildInput: (params) => {
            const { videoUri } = params;
            return {
                // 视频 URL
                video: videoUri,
            };
        },
    },
};